// 用户答题模块
export default {
  UserAnswer: {
    YouHaveAlreadyAnswered: '您之前已经回答了',
    Question: '题',
    DoYouWantToContinue: '是否继续上次回答',
    PreviewOrPrint: '预览或打印',
    ReAnswerQuestions: '重新答题',
    ContinueAnsweringQuestions: '继续答题',
    TheQuestionnaireWillBeOpen: '此问卷将开放，请到时再打开此页面！',
    EnterQuestionnairePassword: '请输入问卷密码',
    EnterPassword: '请输入密码',
    Determine: '确定',
    ShareTo: '分享至',
    ClickToView: '点击查看',
    Statistics: '统计',
    ShareOnWeChatMoments: '分享到微信朋友圈',
    WantToContinue: '您是否继续答题',
    NoActionTaken: '若长时间未有任何操作，系统将自动提交考卷',
    SubmitTo: '提交',
    YouHaveLeftTheExam: '您已离开考试',
    Times: '次',
    Leave: '离开次数达到',
    WillBeForcedToSubmitThePaper: '次将强制交卷',
    NeedToOpenOnWeChat: '您需要在微信中打开才能参与',
    ScanQRCodeUsingWeChat: '用微信扫一扫下面的二维码',
    CopyThisPageAddress: '你可复制本页面地址，通过在微信中发送消息来打开',
    WeChatLoginRequired: '微信登录后才能参与',
    OneClickLogin: '一键登录',
    Loading: '正在加载...',
    RateTheOptions: '请为选项打分',
    SelectOptions: '请选择选项',
    SelectDate: '请选择日期',
    SortAllOptions: '请对所有选项进行排序',
    SelectedPosition: '请选择位置',
    EnsureCompleteAnswers: '请确保答案完整',
    Timing: '请选择时间',
    ChooseAnOption: '请选择一个选项',
    CheckTheAnswers: '请检查答案',
    InputContent: '请输入内容',
    UploadFiles: '请上传文件',
    SelectSpecificGravity: '请选择比重',
    StatisticsPageToBeImproved: '统计页面待完善',
    UploadFailed: '上传失败！',
    Submitting: '正在提交...',
    Prompt: '提示',
    TheAnswerIsNotRecorded: '当前为预览页面，答案不被记录。',
    IsOver: '结束了',
    NothingInTheWorld: '这里什么也没有~',
    Staging: '暂存',
    ScanQRCodeToAnswerQuestions: '扫码答题',
    Report: '举报',
    DongfangAixueProvidesSupport: '东方艾学提供支持',
    Print: '打印',
    DataPreparationInProgress: '数据准备中，预计5分钟后完成。前往',
    CanViewProgress: '可查看进度',
    MyDownload: '我的下载',
    QuotaIsFull: '配额已满',
    SuccessfullyStaged: '暂存成功',
    PleaseEnter: '请输入',
    Other: '其他',
    PleaseSelect: '请选择',
    Small: '小',
    Middle: '中',
    TotalSpecificGravity: '比重总和',
    Big: '大',
    Year: '年',
    Month: '月',
    Day: '日',
    GetLocation: '点击获取地理位置',
    YourLocation: '您的位置',
    SearchAddress: '输入关键字搜索地址',
    Clear: '清除',
    SelectAProvince: '请选择省份',
    SelectACity: '请选择城市',
    SelectADistrict: '请选择区/县',
    DetailedAddress: '详情地址',
    UploadFileImages: '上传文件图片',
    UploadFilesWithin10M: '选择上传文件(10M以内)',
    TheFileSizeCannotExceed10MB: '上传文件大小不能超过 10MB!',
    MaximumNumberOfTimes: '已达到文件上传最大次数',
    FailedToUploadFile: '上传文件失败',
    SelectCascadingOption: '请选择级联选项',
    SelectTheFollowingImage: '请选择以下图片',
    MaximumSelection: '选项最多选择',
    Options: '项',
    MinimalSelection: '选项最少选择',
    CheckTheAnswers: '请检查答案',
    OnlineQuestionnaire: '在线问卷',
    ExplanationScores: '得分解释：',
    ExplanationScoresA: '如果您得分为',
    ExplanationScoresB: '表示您对该量表的',
    ExplanationScoresC: '维度有轻微的偏好，但您基本上保持平衡。',
    ExplanationScoresD: '表示您对该量表的',
    ExplanationScoresE: '维度有中度的偏好，您将更容易在偏向该维度的教学环境中学习。',
    ExplanationScoresF: '表示您对该量表的',
    ExplanationScoresG: '维度有强烈的偏好。在不支持该偏好的环境中，您可能会面临学习上的真正困难。'
  },
};